import client from "./api";

export const fetchDreams = async (q = "", category = "Todas") => {
  const params = {};
  if (q) params.q = q;
  if (category && category !== "Todas") params.category = category;
  const { data } = await client.get("/tools/dreams", { params });
  return data;
};

export const fetchMirrorHours = async (kind) => {
  const params = kind ? { kind } : {};
  const { data } = await client.get("/tools/mirror-hours", { params });
  return data;
};

export const fetchJaladoraTable = async () => {
  const { data } = await client.get("/tools/jaladora");
  return data;
};

export const fetchJaladoraFor = async (number) => {
  const { data } = await client.get(`/tools/jaladora/${number}`);
  return data;
};

export const calc1220 = async (birthdate) => {
  const { data } = await client.post("/tools/numerology/1220", { birthdate });
  return data;
};

export const calcCruz = async (name, birthdate) => {
  const { data } = await client.post("/tools/numerology/cruz", { name, birthdate });
  return data;
};

export const calcHoroscopo = async (birthdate) => {
  const { data } = await client.post("/tools/numerology/horoscopo", { birthdate });
  return data;
};

export const fetchInversos = async () => {
  const { data } = await client.get("/tools/numerology/inversos");
  return data;
};

export const interpretNumber = async (number) => {
  const { data } = await client.post("/tools/interpret", { number });
  return data;
};
